<template>
  <div class="event-review" v-if="!isMobile && imageFile.length > 0">
    <event-detail-title :type="anchorMap.REVIEW_KEY">
      <template #right v-if="linkFile.length > 0">
        <span class="title-right-mark" @click="linkToAllReview">
          查看全部回放
          <div class="iconfont icon-jiantou right-arrow"></div>
        </span>
      </template>
    </event-detail-title>
    <div class="section-content">
      <event-detail-swiper :data="imageFile"></event-detail-swiper>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import vueTypes from 'vue-types'
import eventDetailTitle from './event-detail-title'
import eventDetailSwiper from './event-detail-swiper'
import { anchorMap, DATA_TYPE } from './utils'

export default {
  data () {
    return {
      anchorMap
    }
  },
  props: {
    res: vueTypes.array.isRequired
  },
  components: {
    eventDetailTitle,
    eventDetailSwiper
  },
  methods: {
    linkToAllReview () {
      const url = this.linkFile[0].url
      window.open(url, '_blank')
    }
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    }),
    imageFile () {
      const type = DATA_TYPE.get('image')
      return this.res?.filter(item => item.type === type) || []
    },
    linkFile () {
      const type = DATA_TYPE.get('link')
      return this.res?.filter(item => item.type === type) || []
    }
  }
}
</script>

<style lang="scss" scoped>
.event-review {
  margin-bottom: 30px;

  .title-right-mark {
      position: relative;
      padding-right: 10px;
      line-height: 12px;
      font-size: 12px;
      font-weight: 400;
      color: #353535;
      cursor: pointer;

      .right-arrow {
        position: absolute;
        top: 0;
        right: -7px;
        font-size: 22px;
      }
  }
}
</style>
